import React from "react";
import { useField } from "formik";

import {
  FieldSet,
  Input,
  Error,
  Prefix,
  InputWrapper,
  Suffix,
  Info,
  Required
} from "./input.style";

interface IInputProps {
  label: string;
  name: string;
  prefix?: string;
  suffix?: string;
  info?: string;
  required?: boolean;
}

const InputComponent: React.FC<
  IInputProps & Omit<React.HTMLProps<HTMLInputElement>, "label">
> = (props: IInputProps & Omit<React.HTMLProps<HTMLInputElement>, "label">) => {
  const { name, label, prefix, suffix, info, required } = props;
  const [field, meta] = useField(name);
  return (
    <FieldSet>
      <label>
        {label} 
        {required && <Required>*</Required>}
        <InputWrapper>
          {prefix && <Prefix>{prefix}</Prefix>}
          <Input {...field} {...props} />
          {suffix && <Suffix>{suffix}</Suffix>}
        </InputWrapper>
      </label>
      {info && <Info>{info}</Info>}
      {meta.touched && meta.error ? <Error>{meta.error}</Error> : null}
    </FieldSet>
  );
};

export default InputComponent;
